export enum PB_SUPPORTED_FEATURES {
  MERCHANDISE = "Merchandise",
  GROUP_CELEBRATION = "GroupCelebration"
}
